.root {
  align-items: center;
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  cursor: text;
  display: flex;
  flex-wrap: wrap;
  font-family: inherit;
  font-size: 14px;
  gap: 6px;
  min-height: 36px;
  padding: 4px 8px;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:focus-within {
    border-color: var(--color-focus);
    box-shadow: 0 0 0 2px var(--color-focus);
  }
}

.root-size-sm {
  min-height: 32px;
  padding: 4px 8px;
}

.root-size-default {
  min-height: 36px;
  padding: 4px 8px;
}

.root-size-lg {
  min-height: 40px;
  padding: 4px 10px;
}

.root-is-disabled {
  background: var(--color-secondary);
  cursor: not-allowed;
  opacity: 0.6;

  &:focus-within {
    border-color: var(--color-border);
    box-shadow: none;
  }
}

.list {
  align-items: center;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  gap: 6px;
  list-style: none;
  margin: 0;
  min-width: 0;
  padding: 0;
}

.tag {
  align-items: center;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 999px;
  color: var(--color-foreground);
  display: inline-flex;
  font-size: 13px;
  gap: 4px;
  padding: 2px 4px 2px 10px;
}

.tagLabel {
  line-height: 1.2;
}

.tagRemove {
  align-items: center;
  background: none;
  border: 0;
  border-radius: 999px;
  color: var(--color-muted);
  cursor: pointer;
  display: inline-flex;
  height: 18px;
  justify-content: center;
  padding: 0;
  width: 18px;

  &:hover {
    background: var(--color-background);
    color: var(--color-foreground);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.inputItem {
  flex: 1;
  min-width: 60px;
}

.input {
  background: transparent;
  border: 0;
  color: var(--color-foreground);
  font-family: inherit;
  font-size: 14px;
  outline: none;
  padding: 4px 2px;
  width: 100%;

  &::placeholder {
    color: var(--color-placeholder);
  }

  &:disabled {
    cursor: not-allowed;
  }
}
